// extracted by mini-css-extract-plugin
module.exports = {"Bar":"Bar_Bar__1w5Tx"};